import { DataEntityBase, Models } from ".";
import { IConstructorOptions } from "../../../Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";


enum Properties {
    text = '_text',
    isComplete = '_isComplete'
}

export class SimpleText extends DataEntityBase {

    
    public static get TypeName() { return Models.SimpleText; }

    public static CreateId(key: string) {
        return DataEntityBase.CreateId(SimpleText.TypeName, key)
    };


    public static Create(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        var retVal = new SimpleText(options);
        watcher.RegisterEntity(retVal);
        return retVal;
    }

    public get text(): string { return this[Properties.text]; }
    public set text(value: string) { this.UpdateAndFire(Properties.text, value); }
    [Properties.text] = '';

    public get isComplete(): boolean { return this[Properties.isComplete]; }
    public set isComplete(value: boolean) { this.UpdateAndFire(Properties.isComplete, value); }
    [Properties.isComplete] = false

    protected constructor(options?: IConstructorOptions) {

        super(
            {
                typename: SimpleText.TypeName,
                serializationProperties: Properties,
                dateProperties: SimpleText.completableDateProperties,
                jsonProperties: SimpleText.completableJsonProperties
            });
            this.CompleteConstruction(options);
    }


    private static completableDateProperties: string[] = [
    ];


    private static completableJsonProperties: string[] = [
    ];

}